import { useState, useEffect } from "react";
import { supabase } from "../integrations/supabase/client";

export type PeriodDays = 7 | 30 | 90;

export interface DashboardInsights {
  period_days: number;
  review_growth: number;
  review_growth_percent: number;
  this_period_count: number;
  last_period_count: number;
  this_week_count: number;
  last_week_count: number;
  rating_delta: number;
  current_avg_rating: number;
  overall_avg_rating: number;
  intercepted_reviews: number;
  rating_preserved: number;
  response_rate: number;
  handled_count: number;
  needs_attention_count: number;
  estimated_revenue_impact_percent: number;
  trust_score: number;
  trust_score_components: { rating: number; volume: number; sentiment: number };
  before: { reviews: number; rating: number; negativePercent: number; responseRate: number };
  after: { reviews: number; rating: number; negativePercent: number; responseRate: number };
  total_reviews: number;
  positive_this_week: number;
}

export const PERIOD_LABELS: Record<PeriodDays, { short: string; current: string; previous: string }> = {
  7: { short: "7 days", current: "this week", previous: "last week" },
  30: { short: "30 days", current: "last 30 days", previous: "previous 30 days" },
  90: { short: "90 days", current: "last 90 days", previous: "previous 90 days" },
};

export const useDashboardInsights = (selectedOutlets: string[], periodDays: PeriodDays = 7, supabaseoutletIDs:string[]) => {
  const [insights, setInsights] = useState<DashboardInsights | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const isAll =  !selectedOutlets ||  selectedOutlets.length === 0 ||  selectedOutlets.flat().includes("all");
        const { data, error } = await supabase.functions.invoke("dashboard-insights", {
          body: { outlet_ids: isAll ? supabaseoutletIDs : selectedOutlets, period_days: periodDays },
        });
        if (error) throw error;
        setInsights(data);
      } catch (err) {
        console.error("Failed to load insights:", err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [selectedOutlets, periodDays]);

  return { insights, loading };
};
